<template>
    <div>
        <div class="d-flex flex-column h-100">
            <div>
                <pc-search
                    ref="listSearch"
                    v-bind:dynamic="dynamic"
                    v-on:search="search" />
            </div>
            <slot name="categories" />
            <div
                class="overflow-auto flex-grow-1"
                v-bind:style="listWrapperStypeObject">
                <slot
                    v-bind:list="filteredList"
                    v-bind:search-term="parsedSearchTerm" />
            </div>
        </div>
    </div>
</template>

<script>
    import { escapeRegex } from "Util/util";
    import { useFilterableList } from "./filterableList";
    import { ref, toRef } from "vue";

    export default {
        props: {
            items: { type: Array, required: true },
            filter: { type: Function, required: true }, // Parameters (Item, SearchTerm)
            dynamic: {
                type: Object,
                required: false,
                default() {
                    return { debounce: 250, reactive: true };
                }
            },
            searchTermParser: {
                type: Function,
                required: false,
                default(searchTerm) {
                    return new RegExp(escapeRegex(searchTerm), "i");
                }
            },
            listMaxHeight: { type: Number, required: false, default: null }
        },
        emits: ["search-term-changed"],
        setup(props) {
            const searchTerm = ref("");
            const reactiveItems = toRef(() => props.items);
            return {
                ...useFilterableList(reactiveItems, searchTerm, props.filter, props.searchTermParser),
                searchTerm
            };
        },
        computed: {
            listWrapperStypeObject() {
                if (!this.listMaxHeight) {
                    return null;
                }
                return {
                    maxHeight: `${this.listMaxHeight}px`
                };
            }
        },
        methods: {
            search(searchTerm) {
                this.searchTerm = searchTerm;
                this.$emit("search-term-changed", this.parsedSearchTerm);
            },
            clear() {
                this.$refs.listSearch.clear({ skipEmit: false });
            },
            setSearchTerm(searchTerm) {
                this.$refs.listSearch.setSearchTerm(searchTerm, false);
            },
            focusIn() {
                this.$refs.listSearch?.focusIn();
            }
        }
    };
</script>
